import {MenuItemList} from '@yasc/yasc-material-components';
import {PermissionList} from '../core/permissions/permission-list';


export const MENU_ITEMS: MenuItemList[] = [
    {
        prefix: "cp",
        name: "navCp",
        icon: "group",
        requiredPermission: PermissionList.ModuleCP,
        _opened: false,
        hasMainPage: false,
        children: [
            {
                label: "sidebarHome",
                link: "/home"
            },
            // {
            //     label: "sidebarProducts",
            //     link: "/product"
            // },
            {
                label: "sidebarLicenceManagement",
                link: "/management",
                requiredPermission: PermissionList.LicenseAssign,
            },
        ]
    },
    {
        prefix: "crm",
        name: "navCrm",
        icon: "diversity_3",
        hasMainPage: false,
        requiredPermission: PermissionList.ModuleCRM,
        _opened: false,
        children: [
            {
                label: "navButtonProject",
                link: "/project",
                requiredPermission: PermissionList.ProjectSearch
            },
            // {
            //     label: 'app_navigation_task_label',
            //     link: '/task',
            //     requiredPermission: PermissionList.TaskSearch
            // },
            // {
            //     label: "navButtonTracker",
            //     link: "/acquisition"
            // },
            // {
            //     label: "navButtonWorkflow",
            //     link: "/workflow",
            //     requiredPermission: PermissionList.WorkflowSearch
            // },
            {
                label: 'navButtonCompany',
                link: '/company',
                requiredPermission: PermissionList.CompanySearch
            },
            {
                label:'navButtonContacts',
                link: '/contacts'
            }
        ]
    },
    {
        prefix: "rm",
        requiredPermission: PermissionList.ModuleRM,
        name: "navResources",
        icon: "calendar_month",
        hasMainPage: false,
        _opened: false,
        children: [
            // {
            //     label: "navButtonHumanResources",
            //     link: "/humanResources"
            // },
            {
                label: "navButtonProjectBudgets",
                link: "/project-budgets",
                requiredPermission: PermissionList.ProjectDetails
            },
            {
                label: "app_navigation_timeManagement_label",
                link: "/timeTracker"
            },
            {
                label: "navButtonEmployeeTimeOverview",
                link: "/employee-time-overview",
                requiredPermission: PermissionList.CalendarSearch
            },
            {
                label:"app_navigation_vacationManagement_label",
                link: "/vacation-management"
            },
            {
                label: "app_navigation_vacationApproval_label",
                link: "/approve",
                requiredPermission: PermissionList.CalendarCancelOwn,
            },
        ]
    },
    {
        prefix: "fibu",
        name: "navFibu",
        requiredPermission: PermissionList.ModuleFibu,
        icon: "calculate",
        _opened: false,
        hasMainPage: false,
        children: [
            {
                label: "navFibBatchBooking",
                link: "/batchbooking",
                requiredPermission: PermissionList.FibuBookingSearch
            },
            {
                label: "navFibJournal",
                link: "/journal",
                requiredPermission: PermissionList.FibuBookingSearch
            },
            {
                label: "navFibOffers",
                link: "/offers",
                requiredPermission: PermissionList.OfferSearch
            },
            {
                label: "navFibInvoices",
                link: "/invoices",
                requiredPermission: PermissionList.InvoiceSearch
            },
            {
                label: "navFibRecurring",
                link: "/recurring",
                requiredPermission: PermissionList.FibuBookingSearch
            },
            {
                label: "navFibTemplates",
                link: "/import-templates",
                requiredPermission: PermissionList.FibuBookingImport
            },
            {
                label: "navFibAccountPlan",
                link: "/account-plan",
                requiredPermission: PermissionList.FibuAccountsSearch
            },
            {
                label: "navFibExport",
                link: "/export",
                requiredPermission: PermissionList.FibuBookingExport
            },
        ]
    },
    {
        prefix: "finances",
        name: "navFin",
        requiredPermission: PermissionList.ModuleFinances,
        icon: "account_balance",
        hasMainPage: false,
        _opened: false,
        children: [
            {
                label: "finBank",
                link: "/bank",
                requiredPermission: PermissionList.FibuBankSearch
            },
            {
                label: "finTransactions",
                link: "/transactions",
                requiredPermission: PermissionList.FibuBankTransactionsSearch,
            }
        ]
    },
    // update starts here
    {
        prefix: "contracts",
        name: "navContracting",
        requiredPermission: PermissionList.ModuleContracts,
        icon: "library_books",
        hasMainPage: false,
        _opened: false,
        children: [
            {
                label: "navContractAssignment",
                link: "/contract-assignment"
            },
            {
                label: "navLicenseAssignment",
                link: "/license-assignment",
                requiredPermission: PermissionList.ContractingCreate,
            },
            {
                label: "navDeviceData",
                link: "/device-data",
                requiredPermission: PermissionList.ContractingDeviceDataList
            },
            {
                label: "navLicenseData",
                link: "/license-data",
                requiredPermission: PermissionList.ContractingLicenseDataList
            }
        ]
    },
    {
        prefix: "inventory",
        name: "navInventory",
        icon: "library_books",
        requiredPermission: PermissionList.ModuleInventory,
        _opened: false,
        hasMainPage: true,
        children: [
            {
                label: "navArticle",
                link: "/article",
                requiredPermission: PermissionList.InventoryArticleList
            },
            {
                label: "navComputer",
                link: "/computer",
                requiredPermission: PermissionList.InventoryComputerList
            },
            {
                label: "navDisplay",
                link: "/display",
                requiredPermission: PermissionList.InventoryDisplayList
            },
        ]
    },
];
